(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/reminder/assets/javascripts/reminder.js') >= 0) return;  svs.modules.push('/components/tur/reminder/assets/javascripts/reminder.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useEffect = _React.useEffect,
  forwardRef = _React.forwardRef,
  useState = _React.useState,
  useRef = _React.useRef,
  useCallback = _React.useCallback;
const Icon = svs.ui.ReactIcon;
const Reminder = forwardRef((_ref, ref) => {
  let _ref$scrollConfig = _ref.scrollConfig,
    scrollConfig = _ref$scrollConfig === void 0 ? {} : _ref$scrollConfig;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    elementInViewPort = _useState2[0],
    setElementInViewPort = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    reminderClicked = _useState4[0],
    setReminderClicked = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    reminderShown = _useState6[0],
    setReminderShown = _useState6[1];
  const mountedRef = useRef(false);
  const tl = useRef();
  const divRef = useRef();
  const buttonRef = useRef();
  const animations = useRef();
  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);
  useEffect(() => {
    if (divRef !== null && divRef !== void 0 && divRef.current && buttonRef !== null && buttonRef !== void 0 && buttonRef.current) {
      animations.current = svs.tur.reminder.animations(divRef === null || divRef === void 0 ? void 0 : divRef.current, buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current);
    }
  }, [divRef, buttonRef]);
  useEffect(() => {
    if (ref !== null && ref !== void 0 && ref.current) {
      const observer = new IntersectionObserver(entries => {
        if (entries && entries[0]) {
          mountedRef.current && setElementInViewPort(entries[0].isIntersecting);
        }
      });
      observer.observe(ref.current);
    }
  }, [ref.current, setElementInViewPort]);
  useEffect(() => {
    let timeout;
    if (!reminderShown) {
      if (!elementInViewPort) {
        show();
      } else {
        timeout = setTimeout(() => {
          setReminderShown(true);
        }, 1000);
      }
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [elementInViewPort, reminderShown, setReminderShown]);
  useEffect(() => {
    elementInViewPort && hide();
  }, [elementInViewPort]);
  const show = useCallback(() => {
    if (!tl.current) {
      const showTimeline = gsap.timeline({
        onComplete: () => {
          tl.current = null;
        }
      });
      showTimeline.addLabel('show');
      showTimeline.add(animations.current.containerUp());
      showTimeline.add(animations.current.arrowUp(), "-=0.8");
      showTimeline.add(animations.current.arrowWiggle());
      showTimeline.add(animations.current.arrowMinimize());
      showTimeline.addLabel('minimize');
      showTimeline.addLabel('hide');
      showTimeline.add(animations.current.containerDown(), "-=0.3");
      showTimeline.add(animations.current.arrowDown(), '+=2');
      tl.current = showTimeline;
    } else {
      if (!tl.current.isActive()) {
        tl.current.restart();
      }
    }
    return tl === null || tl === void 0 ? void 0 : tl.current;
  }, [tl.current]);
  const hide = useCallback(function () {
    let onComplete = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : () => ({});
    if (tl.current) {
      tl.current.pause();
      const hideTL = gsap.timeline({
        onComplete
      });
      hideTL.add(animations.current.containerDown().timeScale(3));
      hideTL.add(animations.current.arrowDown().timeScale(1.4));
      hideTL.call(() => {
        if (tl.current) {
          tl.current.progress(1);
        }
      });
    }
  }, [tl.current]);
  const scrollToElement = useCallback(() => {
    var _ref$current;
    const _scrollConfig$yOffset = scrollConfig.yOffset,
      yOffset = _scrollConfig$yOffset === void 0 ? 0 : _scrollConfig$yOffset;
    const y = (ref === null || ref === void 0 || (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.getBoundingClientRect().top) + window.scrollY - yOffset;
    window.scrollTo({
      top: y,
      behavior: 'smooth'
    });
  }, [ref.current]);
  const handleClick = useCallback(e => {
    e === null || e === void 0 || e.preventDefault();
    scrollToElement();
    hide(() => {
      setReminderClicked(true);
      setReminderShown(true);
    });
  }, [scrollToElement, setReminderClicked, setReminderShown]);
  const handleMouseEnter = useCallback(e => {
    var _tl$current;
    e === null || e === void 0 || e.preventDefault();
    if (tl !== null && tl !== void 0 && (_tl$current = tl.current) !== null && _tl$current !== void 0 && _tl$current.isActive() && !reminderClicked) {
      tl.current.pause();
    }
  }, [tl.current, reminderClicked]);
  const handleMouseLeave = useCallback(e => {
    var _tl$current2;
    e === null || e === void 0 || e.preventDefault();
    if (tl !== null && tl !== void 0 && (_tl$current2 = tl.current) !== null && _tl$current2 !== void 0 && _tl$current2.paused() && !reminderClicked) {
      tl.current.resume();
    }
  }, [tl.current, reminderClicked]);
  return React.createElement("div", {
    className: "reminder-default reminder",
    ref: divRef
  }, React.createElement("button", {
    className: "reminder-bubble",
    onClick: handleClick,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    ref: buttonRef,
    title: "Forts\xE4tt",
    type: "button"
  }, React.createElement(Icon, {
    color: "fc-white",
    icon: "menu-down"
  })));
});
setGlobal('svs.tur.Reminder', Reminder);

 })(window);